import { render, staticRenderFns } from "./PPcSearchKit.vue?vue&type=template&id=b68c7092&scoped=true&"
import script from "./PPcSearchKit.vue?vue&type=script&lang=ts&"
export * from "./PPcSearchKit.vue?vue&type=script&lang=ts&"
import style0 from "./PPcSearchKit.vue?vue&type=style&index=0&id=b68c7092&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68c7092",
  null
  
)

export default component.exports